import { render, staticRenderFns } from "./ClientNotesManagement.vue?vue&type=template&id=41f5abee&scoped=true"
import script from "./ClientNotesManagement.vue?vue&type=script&lang=js"
export * from "./ClientNotesManagement.vue?vue&type=script&lang=js"
import style0 from "./ClientNotesManagement.vue?vue&type=style&index=0&id=41f5abee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f5abee",
  null
  
)

export default component.exports